<template>

    <div class="flex-gallery z-0">

        <div class="flexslider">

            <ul class="slides">

                <li v-for="(image, key) in images" :key="key">

                    <a :href="image.src" class="magnific">

                        <div class="bg-cover bg-bottom" :class="imageClass" :style="'background-image:url(' + image.src + ');min-width:' + minWidth + ';min-height:' + minHeight + ';'"></div>

                    </a>

                </li>

            </ul>

        </div>

    </div>

</template>

<script>

export default {

  name: 'ImageSlider',

  props: {

    images     : { type: Array,  default: [] },
    minWidth   : { type: String, default: '150px' },
    minHeight  : { type: String, default: '100px' },
    imageClass : { type: String, default: '' }

  },

  mounted() {

    this.$nextTick(() => {

        jQuery(this.$el).find('.flexslider').flexslider({
            animation: 'fade',
            smoothHeight: false,
            animationSpeed: 500,
            useCSS: false,
            touch: true,
            prevText: '<i class="fa fa-angle-left"></i>',
            nextText: '<i class="fa fa-angle-right"></i>'
        });


        jQuery(this.$el).find('.slides').magnificPopup({
            type: 'image',
            delegate: 'a.magnific',
            gallery:{ enabled: true },
            removalDelay: 400,
        });

    });

  }

}
</script>
